import { useMemo } from 'react';
import { Switch } from '@mui/material';

import { MODULES } from '../../../../constants/Modules';
import { DataColectorsDevice } from './types';

import { Wrapper } from '../styles';
import Table from '../../../../components/Table';
import Status from '../../../../components/Table/Columns/Status';
import Value from '../../../../components/Table/Columns/Value';
import { fullFiltersOverview, generalFilters } from '../filters';

export default function DataColectors() {
  const renderChild = (value: number | string | null) => value ? value : 'no data';

  const table = useMemo(
    () => (
      <Table
        title="Data Collectors"
        exportData={{
          csv: {
            url: `/devices/${MODULES.MODULE_DC}/export-csv`
          }
        }}
        filter={{
          inputs: [
            ...generalFilters(MODULES.MODULE_DC),
            ...fullFiltersOverview
          ]
        }}
        options={{
          moduleName: 'dc',
          apiUrl: `/devices/${MODULES.MODULE_DC}/search`,
          dataSourceKey: 'items',
          dataStoreKey: 'id',
          searchKey: ''
        }}
        columns={[
          {
            caption: 'Acc. Number',
            dataField: 'companyId',
            calculateSortValue: 'companyId',
            alignment: 'center',
            width: '5%',
            cellRender: ({ data } : { data: DataColectorsDevice }) => <Value data={data.companyId}/>
          },
          {
            caption: 'Device Serial',
            dataField: 'deviceSerial',
            calculateSortValue: 'deviceSerial',
            width: '10%',
            minWidth: 100,
            cellRender: ({ data } : { data: DataColectorsDevice }) => <Value data={data.deviceSerial}/>
          },
          {
            dataField: 'model',
            caption: 'Model',
            calculateSortValue: 'model',
            width: '6%',
            cellRender: ({ data } : { data: DataColectorsDevice }) => <Value data={data.model}/>
          },
          {
            dataField: 'location',
            caption: 'Location',
            calculateSortValue: 'location',
            width: '10%',
            cellRender: ({ data } : { data: DataColectorsDevice }) => <Value data={data.location}/>
          },
          {
            dataField: 'companyName',
            caption: 'Company',
            calculateSortValue: 'companyName',
            width: '11%',
            cellRender: ({ data } : { data: DataColectorsDevice }) => <Value data={data.companyName}/>
          },
          {
            caption: 'State',
            dataField: 'state',
            calculateSortValue: 'state',
            width: '7%',
            cellRender: ({ data } : { data: DataColectorsDevice }) => <Value data={data.state}/>
          },
          {
            caption: 'CC Serial',
            dataField: 'ccSerial',
            calculateSortValue: 'ccSerial',
            width: '6%',
            cellRender: ({ data } : { data: DataColectorsDevice }) => <Value data={data.ccSerial}/>
          },
          {
            caption: 'SIM',
            dataField: 'sim',
            calculateSortValue: 'sim',
            width: '10%',
            minWidth: 100,
            cellRender: ({ data } : { data: DataColectorsDevice }) => <Value data={data.sim}/>
          },
          {
            caption: 'Contact e-mail',
            dataField: 'contactEmail',
            calculateSortValue: 'contactEmail',
            width: '11%',
            cellRender: ({ data } : { data: DataColectorsDevice }) => <Value data={data.contactEmail}/>
          },
          {
            caption: 'Renewal date',
            dataField: 'subscriptionExpiresAt',
            calculateSortValue: 'subscriptionExpiresAt',
            width: '10%',
            cellRender: ({ data } : { data: DataColectorsDevice }) => <Value data={data.subscriptionExpiresAt}/>
          },
          {
            caption: 'Last comm.',
            dataField: 'lastCommunicatedAt',
            calculateSortValue: 'lastCommunicatedAt',
            width: '13%',
            cellRender: ({ data } : { data: DataColectorsDevice }) => (
              <Status
                success={!!data.timeStatus}
                disabled={!data.lostCommunication}
              >
                {renderChild(data.lastCommunicatedAt)}
              </Status>
            ),
          },
          {
            dataField: 'battery',
            caption: 'Battery',
            calculateSortValue: 'battery',
            width: '5%',
            alignment: 'left',
            cellRender: ({ data } : { data: DataColectorsDevice }) => (
              <Status
                success={!!data.batteryStatus}
                disabled={!data.lostCommunication}
              >
                {`${renderChild(data.battery)} / ${data.normalVoltage}v`}
              </Status>
            ),
          },
          {
            type: 'buttons',
            name: '',
            caption: '',
            width: '4%',
            alignment: 'left',
            cssClass:'padding-left-1',
            cellRender: ({ data } : { data: DataColectorsDevice }) =>
              <Switch disabled={true} data-test={`switchDevice_${data.id}`}/>,
          }
        ]}
      />
    ),
    []
  );

  return (
    <Wrapper className="data-colectors" data-test="data-colectors">
      {table}
    </Wrapper>
  );
}
